module.exports = __webpack_public_path__ + "0653fdd30554cbfd02a454562188f863.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/target_2022_chart.png
// module id = 1746
// module chunks = 0